import {all, put, select, takeLatest} from "redux-saga/effects";
import {executeAxiosWithExceptionHandling, handleAxiosException} from "./index";
import axios from "axios";

function* fetchFormTemplate(action) {
    try {
        let state = yield select();
        let response = yield executeAxiosWithExceptionHandling(() => axios.get(`/hotdeals/rest/forms/${action.friendlyName}?lang=${state.language.currentLanguage}`));

        yield put({
            type: 'FORM_TEMPLATE_FETCHED',
            formTemplate: response.data
        });
    } catch (exception) {
        if (exception && exception.response && exception.response.status === 404) {
            yield put({
                type: 'FORM_TEMPLATE_NOT_FOUND'
            });
        } else {
            yield handleAxiosException(exception);
        }
    }
}

function* submitFormData(action) {
    try {
        yield executeAxiosWithExceptionHandling(() => axios.post(`/hotdeals/rest/forms/${action.friendlyName}/submit`, action.formData));
        yield put({
            type: 'FORM_DATA_SUBMITTED'
        });
    } catch (exception) {
        if (exception && exception.response) {
            if (exception.response.status === 409 || exception.response.status === 404) {
                // 409: form already submitted; refetch it so the formTemplateDetail has submitted = true
                // 404: end date was changed to today or user is removed from whitelist while he was filling in the form
                yield put({
                    type: 'FETCH_FORM_TEMPLATE',
                    friendlyName: action.friendlyName
                });
            } else if (exception.response.status === 400) {
                // frontend validation allowed to submit form, but backend didn't: probably the form template config was updated in the meantime: refetch form
                yield put({
                    type: 'MISSING_FORM_FIELDS'
                });
                yield put({
                    type: 'FETCH_FORM_TEMPLATE',
                    friendlyName: action.friendlyName,
                    silentRefetch: true
                });
            } else if (exception.response.status === 412) {
                if (exception.response.data === "Invalid phone number")
                    yield put({
                        type: 'INVALID_PHONE_NUMBER',
                        friendlyName: action.friendlyName
                    });
                else if (exception.response.data === "Invalid email address") {
                    yield put({
                        type: 'INVALID_EMAIL_ADDRESS',
                        friendlyName: action.friendlyName
                    });
                } else
                    yield handleAxiosException(exception);
            }
        } else {
            yield handleAxiosException(exception);
        }
    }
}

export default function* formTemplateSaga() {
    yield all([
        takeLatest(['FETCH_FORM_TEMPLATE'], fetchFormTemplate),
        takeLatest('SUBMIT_FORM_DATA', submitFormData)
    ]);
}